import React, { useState } from "react";
import DeliveryPreferenceComponent from "./DeliveryPreferenceComponent";
import TemplatePicker from "./TemplatePicker";
import './CreateSequenceStyles.css';

const StepperComponent = ({
  stepNumber,
  onAddStep,
  onChange,
  stepData,
  disableAdd,
  header,
}) => {
  const [sendAfter, setSendAfter] = useState(stepData.sendAfter || 1);
  const [sendUnit, setSendUnit] = useState(stepData.sendUnit || "Days");
  const [templateName, setTemplateName] = useState(stepData.templateName || "abcd");
  const [showDeliveryPref, setShowDeliveryPref] = useState(stepData.showDeliveryPref || false);
  const [deliveryPref, setDeliveryPref] = useState(stepData.deliveryPref || {});
  const [showTemplatePicker, setShowTemplatePicker] = useState(false);  // keep full template object locally for preview
  const [templateDetailsFull, setTemplateDetailsFull] = useState(stepData.templateDetailsFull || null);
  // minimal template info to send to parent (only id + bindings)
  const [templateDetails, setTemplateDetails] = useState(stepData.templateDetails || null);
  // delivery pref states
  const [allDays, setAllDays] = useState(deliveryPref.allDays ?? true);
  const [selectedDays, setSelectedDays] = useState(deliveryPref.selectedDays ?? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']);
  const [deliveryTimeType, setDeliveryTimeType] = useState(deliveryPref.deliveryTimeType ?? 'any');
  const [customTimeFrom, setCustomTimeFrom] = useState(deliveryPref.customTimeFrom ?? '');
  const [customTimeTo, setCustomTimeTo] = useState(deliveryPref.customTimeTo ?? '');

  const headerFields = typeof header === 'string' && header.trim() !== ''
    ? header.split(',').map(h => h.trim())
    : [];
  console.log(stepData, headerFields);
  // notify parent on change
  React.useEffect(() => {
    onChange(stepNumber - 1, {
      sendAfter,
      sendUnit,
      templateDetails,
      showDeliveryPref,
      deliveryPref: showDeliveryPref
        ? { allDays, selectedDays, deliveryTimeType, customTimeFrom, customTimeTo }
        : {},
    });
    // eslint-disable-next-line
  }, [sendAfter, sendUnit, templateDetails, showDeliveryPref, allDays, selectedDays, deliveryTimeType, customTimeFrom, customTimeTo]);

  const handleTemplateConfirm = (templateObj, bindings) => {
    // set display name and store details + bindings
    setTemplateName(templateObj.templateName || 'abcd');
    setTemplateDetailsFull({ ...templateObj, bindings });
    // send minimal info to parent: template id + bindings
    setTemplateDetails({
      template_id: templateObj._id || templateObj.id || null,
      bindings: bindings || {}
    });
    setShowTemplatePicker(false);
  };

  return (
    <>
    <div className="stepper-card row g-0">
      {/* Left 70% */}
      <div className="col-12 col-lg-8 col-md-7 stepper-left">
        <div className="stepper-title">Step {stepNumber}</div>

        <div className="row g-2 align-items-center mb-2">
          <div className="col-auto"><label className="form-label mb-0">Send After</label></div>
          <div className="col-auto">
            <input
              type="number"
              min={1}
              max={100}
              value={sendAfter}
              onChange={e => setSendAfter(Math.max(1, Math.min(100, Number(e.target.value) || 1)))}
              className="form-control"
              style={{ width: 70 }}
            />
          </div>
          <div className="col-auto">
            <select className="form-select" value={sendUnit} onChange={e => setSendUnit(e.target.value)} style={{ width: 100 }}>
              <option value="Days">Days</option>
              <option value="Minutes">Minutes</option>
            </select>
          </div>
        </div>

        <div className="mb-2">
          <label className="form-label">Choose Template</label>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm ms-2"
            style={{ minWidth: 120 }}
            onClick={() => setShowTemplatePicker(true)}
          >
            Pick Template
          </button>
          <span className="ms-2 badge bg-info text-dark">{templateDetails? templateDetails.template_name : ''}</span>
        </div>

        <div className="mb-2" style={{ paddingLeft: '20px' }}>
          <input
            type="checkbox"
            checked={showDeliveryPref}
            onChange={() => setShowDeliveryPref(!showDeliveryPref)}
            id={`customDeliveryPref${stepNumber}`}
            className="form-check-input"
          />
          <label htmlFor={`customDeliveryPref${stepNumber}`} className="form-check-label ms-2">
            Set custom delivery references
          </label>
        </div>

        {showDeliveryPref && (
          <DeliveryPreferenceComponent
            allDays={allDays}
            selectedDays={selectedDays}
            handleAllDaysToggle={() => setAllDays(!allDays)}
            handleDayToggle={day => {
              if (allDays) return;
              setSelectedDays(prev =>
                prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
              );
            }}
            deliveryTimeType={deliveryTimeType}
            setDeliveryTimeType={setDeliveryTimeType}
            customTimeFrom={customTimeFrom}
            setCustomTimeFrom={setCustomTimeFrom}
            customTimeTo={customTimeTo}
            setCustomTimeTo={setCustomTimeTo}
          />
        )}

        <div className="d-flex justify-content-end mt-2" style={{ paddingRight: '5px' }}>
          <button type="button" className="btn btn-success" onClick={onAddStep} disabled={disableAdd}>Add Step</button>
        </div>
      </div>

      {/* Right 30% */}
      <div className="col-12 col-lg-4 col-md-5 stepper-right">
        <div className="template-preview-card">
          <div className="template-preview-title">Template Preview</div>
          <div className="template-preview-content">
            {templateDetailsFull ? (
              <>
                {/* <div className="template-image-placeholder mb-2"> */}
                <div className="mb-2">
                  {/* show one image/video placeholder, replace when real data arrives */}
                  {templateDetailsFull.template_media_url ? (
                    <img
                        src={templateDetailsFull.template_media_url}
                        alt={templateDetailsFull.template_name || templateDetailsFull.title || 'media'}
                        className="template-media-img"
                    />
                    ) : templateDetailsFull.template_type === 'Carousel' && (templateDetailsFull.carousel || []).length > 0 ? (
                    <div className="carousel-scroll">
                        {(templateDetailsFull.carousel || []).map((it, i) => (
                        <div key={i} className="carousel-thumb">{i + 1}</div>
                        ))}
                    </div>
                    ) : (
                    <div className="template-image-placeholder mb-2">No media</div>
                    )}
                </div>
                <div className="template-details-placeholder mb-2">
                  <strong>{templateDetailsFull.template_name || templateDetailsFull.title}</strong>
                  <div className="text-muted small">{templateDetailsFull.template_message_body}</div>
                </div>

                {templateDetailsFull.bindings && Object.keys(templateDetailsFull.bindings).length > 0 && (
                  <div className="mt-2">
                    <div className="text-muted small">Bindings</div>
                    <ul className="list-unstyled small">
                      {Object.entries(templateDetailsFull.bindings).map(([ph, val]) => (
                        <li key={ph}><strong>{ph}</strong> → {val || <em className="text-warning">not mapped</em>}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="template-image-placeholder mb-2"></div>
                <div className="template-details-placeholder text-muted">Template details will appear here.</div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>

    {showTemplatePicker && (
      <TemplatePicker
        onClose={() => setShowTemplatePicker(false)}
        onConfirm={handleTemplateConfirm}
        headerFields={headerFields}
      />
    )}
    </>
  );
};

export default StepperComponent;